import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { prescriptionCounts } from "../-data/fixtures";
import { Link } from "@tanstack/react-router";
import { Activity, Clock, Package, CheckCircle } from "lucide-react";

export default function PrescriptionHub() {
  return (
    <Card className="bg-[#FCFCFC] rounded-2xl">
      <CardContent className="p-0 m-0">
        <div className="flex items-center text-gray-600 px-4 pt-3 pb-2">
          <Activity className="w-4 h-4" />  
          <div className="text-sm ml-1">Prescription Hub</div>
        </div>
        <hr className="mb-2" />
        <div className="flex flex-col gap-3 mt-4 px-4">
          <Row icon={<Clock className="w-4 h-4 text-amber-700" />} label="Pending" hint="Awaiting review" value={prescriptionCounts.pending} tone="amber" />
          <Row icon={<Package className="w-4 h-4 text-blue-700" />} label="Ready" hint="For pickup" value={prescriptionCounts.ready} tone="blue" />
          <Row icon={<CheckCircle className="w-4 h-4 text-green-700" />} label="Refills" hint="Due today" value={prescriptionCounts.refills} tone="green" />
        </div>
      </CardContent>
      <CardFooter className="mt-6">
        <Link to="/prescription-hub" preload="intent" className="w-full text-center border rounded-xl py-3 text-sm">
          View All Prescriptions →
        </Link>
      </CardFooter>
    </Card>
  );
}

function Row({ icon, label, hint, value, tone }: { icon: React.ReactNode; label: string; hint: string; value: number; tone: "amber" | "blue" | "green" }) {
  const bg = tone === "amber" ? "bg-amber-50 ring-amber-500" : tone === "blue" ? "bg-blue-50 ring-blue-500" : "bg-green-50 ring-green-500";
  const text = tone === "amber" ? "text-amber-700" : tone === "blue" ? "text-blue-700" : "text-green-700";
  return (
    <div className={`flex items-center justify-between rounded-xl px-4 py-4 ${bg} ring-1`}>
      <div className="flex items-center">
        <div className="mr-3">{icon}</div>
        <div>
          <div className="text-md font-medium">{label}</div>
          <div className="text-xs text-muted-foreground">{hint}</div>
        </div>
      </div>
      <div className={`text-2xl font-semibold ${text}`}>{value}</div>
    </div>
  );
}